import { reactive, readonly, toRefs } from 'vue'

const state = reactive({
  step: 1,
})

export const step = readonly(toRefs(state).step)
export function setStep(step = 1) {
  state.step = step
}
